export enum CheckboxLabel {
  SharingContactsAgreement = 'I agree to be contacted by Plannery via email and/or at the telephone number(s) I have provided above to explore various financial products and services I inquired about, including contact through automatic dialing systems, artificial or pre-recorded voice messaging, or text message.',
  OtherSourceOfIncome = 'I have any other source of income (Alimony, settlement etc.)',
}
